import { getState } from '~src/state';
import { stopChangeClothes } from './stopChangeClothes';
import { changeImageSrc, getUrlExtension } from '~src/utils';
import { triggerStateChangedRequest } from '~core';
import { onCompleteAttachment } from '~uploader';
import { trackEvent } from '~src/tracking';

export const applyChangeClothes = async () => {
  const selection = getState('changeClothesTarget');
  const imageUrl = getState('changeClothesResultImageUrl');
  const maskUrl = getState('changeClothesMaskUrl');
  const changeClothesItem = getState('changeClothesItem');
  const ext = getUrlExtension(imageUrl);
  const oldImageUrl =
    selection.getSrc() ||
    selection._element.src1 ||
    selection._element.currentSrc;

  onCompleteAttachment({
    successful: [
      {
        name: 'Cambio Vestiti',
        uploadURL: imageUrl,
        type: `image/${ext}`,
        size: 0,
        customAttachmentProps: {
          changeClothesRawImage: oldImageUrl,
          changeClothesMask: maskUrl,
          isChangeClothes: true,
          changeClothesItem,
        },
      },
    ],
  });

  let magicFrame = selection._magicFrame;
  if (selection.type === 'MagicFrame') {
    magicFrame = selection;
  }

  if (magicFrame) {
    await magicFrame.updatePerson(imageUrl);
    magicFrame.scalePersonToWidth(magicFrame.width * magicFrame.scaleX);
    magicFrame.scalePersonToWidth(magicFrame.width * magicFrame.scaleX);
  } else {
    const currentProps = {
      scaleX: selection.scaleX,
      scaleY: selection.scaleY,
      top: selection.top,
      left: selection.left,
    };

    await changeImageSrc(selection, imageUrl);

    selection.set({
      ...currentProps,
    });
  }
  window.canvas.renderAll();

  triggerStateChangedRequest();
  stopChangeClothes();

  trackEvent('AI ChangeClothes Apply');
};
